import moment from "moment";
import { Artist } from "./Artist";
import { Payout } from "./Billing";
import { Host } from "./Host";
import { Message } from "./Message";
import { BasePerson as Person } from "./Person";
import { GLOBAL_CURRENCIES } from '../common/constants';
import { Invoice } from './Billing';
import { Location } from './Location';

export class SCEvent {
  constructor(data) {
    var self = this;
    self.type = "SCEvent";

    self.rootvm = data.rootvm;

    self.perspective = data.perspective;

    self.event_uuid = ko.observable(data.event_uuid);
    self.event_type = ko.observable(data.event_type);
    self.event_title = ko.observable(data.event_title);
    self.external_web_link = ko.observable(data.external_web_link);
    self.artist_uuid = ko.observable(data.artist_uuid);
    self.host_uuid = ko.observable(data.host_uuid);
    self.inserted = ko.observable(new moment(data.inserted));

    self.video_delivered = ko.observable(data.video_delivered);

    self.creator_uuid = ko.observable(data.creator_uuid);

    self.host_login_link = ko.observable();
    self.artist_login_link = ko.observable();

    self.event_info = ko.observable();

    self.location_uuid = ko.observable(data.location_uuid);
    self.location_name = ko.observable();
    self.latitude = ko.observable();
    self.longitude = ko.observable();
    if (data.location) {
      self.location_name(data.location.location_name);
      self.latitude(data.location.latitude);
      self.longitude(data.location.longitude);
    } else if (data.host && data.host.location) {
      self.event_location(e.host.location.location_name);
    }

    self.initiator = ko.observable(data.initiator);

    self.feedback_from_artist = ko.observable(
      new ReviewFeedback(data.feedback_from_artist)
    );
    self.feedback_from_host = ko.observable(
      new ReviewFeedback(data.feedback_from_host)
    );

    self.extra_notes = ko.observable(data.extra_notes);
    self.new_extra_notes = ko.observable(data.extra_notes);
    self.editing_extra_notes = ko.observable(false);

    self.admin_closed = ko.observable(data.admin_closed);
    self.admin_marked = ko.observable(data.admin_marked);

    // TODO: check if needed
    self.calls = ko.observableArray(data.calls);
    self.calls_count = ko.pureComputed(() => self.calls().length);
    self.calls_filter_needed = ko.pureComputed(() => self.calls().some((c) => c.bypass_attempts));

    self.call_bypass_attempts = ko.observableArray(data.call_bypass_attempts || [])

    // If any of the messages need a filter
    self.filter_needed = ko.observable(data.filter_needed);
    self.allow_contact = ko.observable(data.allow_contact);
    self.frontend_events = ko.observable(data.frontend_events);

    // Stored message?
    self.stored_message = ko.observable(data.stored_message);

    self.confirmed_event_date = ko.observable();
    self._confirmed_event_date_moment = ko.observable();
    if (data.confirmed_event_date) {
      self.confirmed_event_date(data.confirmed_event_date);
      self._confirmed_event_date_moment(new moment(data.confirmed_event_date));
    }

    self.pretty_confirmed_event_date = ko.computed(function () {
      if (self._confirmed_event_date_moment()) {
        return self._confirmed_event_date_moment().format("DD.MM.YYYY");
      }
    });

    self.confirmed_event_time = ko.observable();
    self._confirmed_event_time_moment = ko.observable();
    if (data.confirmed_event_time) {
      self.confirmed_event_time(
        new moment(data.confirmed_event_time, "HH:mm").format("LT")
      );
      self._confirmed_event_time_moment(
        new moment(data.confirmed_event_time, "HH:mm")
      );
    }

    self.pretty_confirmed_event_time = ko.computed(function () {
      if (self._confirmed_event_time_moment()) {
        return self._confirmed_event_time_moment().format("LT");
      }
    });

    self.length_of_performance = ko.observable(data.length_of_performance);
    self.length_of_performance_note = ko.observable(
      data.length_of_performance_note
    );

    // These might be there
    self.message_count = ko.pureComputed(() => self.messages()?.length || 0);

    self.latest_message_read = ko.observable(data.latest_message_read);
    self.latest_message_inserted = ko.observable(data.latest_message_inserted);
    self.latest_message_actor = ko.observable(data.latest_message_actor);
    self.latest_message = ko.observable(data.latest_message || "");

    if (self.latest_message_inserted) {
      self.latest_message_inserted(new moment(self.latest_message_inserted()));
    }

    // Welcome paket
    self.paket_address = ko.observable(data.paket_address);
    if (data.paket_sent) {
      self.paket_sent = ko.observable(new moment(data.paket_sent));
    } else {
      self.paket_sent = ko.observable();
    }
    self.paket_extra_notes = ko.observable(data.paket_extra_notes);

    self.current_state = ko.observable();
    if (data.current_state) {
      data.current_state.rootvm = self.rootvm;
      data.current_state.parent_event = self;
      self.current_state = ko.observable(new SCEventState(data.current_state));
    }

    self.host = ko.observable();
    self.artist = ko.observable();
    self.creator = ko.observable();

    self.event_location = ko.observable();

    self.event_privacy = ko.observable(data.event_privacy);
    self.artist_share_phone = ko.observable(data.artist_share_phone);
    self.host_share_phone = ko.observable(data.host_share_phone);

    self.event_history = ko.observableArray([]);
    self.messages = ko.observableArray([]);

    if (data.messages) {
      self.messages(
        ko.utils.arrayMap(data.messages || [], function (x) {
          x.parent_event = self;
          return new Message(x);
        })
      );
    }

    self.host_or_creator_person = new Person(data.host_or_creator_person || {});

    self.creator(new Person(data.creator || {}));

    self.creator().rootvm = self.rootvm;

    // Admin stuff
    self.special_commission_rate = ko.observable();
    self.special_booking_charge_rate = ko.observable();

    self.external_email_address = ko.observable(data.external_email_address);
    self.external_contact_name = ko.observable(data.external_contact_name);
    self.billing_email_address = ko.observable(data.billing_email_address);

    self.commission_invoice = ko.observable();
    self.fee_invoice = ko.observable();

    // Gig offers
    self.gig_offers = ko.observableArray(
      ko.utils.arrayMap(data.gig_offers || [], function (x) {
        x.rootvm = self.rootvm;
        return new SCEvent(x);
      })
    );

    // Related Event
    self.related_events = ko.observableArray(
      ko.utils.arrayMap(data.related_events || [], function (x) {
        x.rootvm = self.rootvm;
        return new SCEvent(x);
      })
    );

    if (data.commission_invoice) {
      data.commission_invoice.rootvm = self.rootvm;
      self.commission_invoice(new Invoice(data.commission_invoice));
    }

    if (data.fee_invoice) {
      data.fee_invoice.rootvm = self.rootvm;
      self.fee_invoice(new Invoice(data.fee_invoice));
    }

    self.host_salutation = ko.computed(function () {
      if (self.host() != undefined && self.host().host_name()) {
        return self.host().host_name();
      } else if (self.creator() != undefined) {
        return self.creator().display_name();
      }
    });

    self.host_person_uuid = ko.pureComputed(function () {
      if (self.host() != undefined && self.host().host_name()) {
        return self.host().person_uuid();
      } else if (self.creator() != undefined) {
        return self.creator().person_uuid();
      }
    });

    if (data.host) {
      self.host(new Host(data.host));
    } else if (self.host_uuid() != undefined) {
      self.host(new Host({ host_uuid: data.host_uuid }));
    } else {
      self.host(new Host({}));
    }

    // The person we need
    self.host_person = ko.observable(new Person({}));
    if (data.host_person) {
      self.host_person(new Person(data.host_person));
    }

    self.host_person().rootvm = self.rootvm;

    if (data.artist) {
      self.artist(new Artist(data.artist || {}));
    } else {
      self.artist(new Artist({ artist_uuid: data.artist_uuid }));
    }

    // Translation stuff
    self.get_linked_artist_name = function () {
      return (
        '<a target="_blank" href="/artists/' +
        self.artist().username() +
        '">' +
        self.artist().artist_name() +
        "</a>"
      );
    };

    self.get_linked_host_display_name = function () {
      if (self.host() != undefined && self.host().host_name()) {
        return (
          '<a target="_blank" href="/hosts/' +
          self.host().host_uuid() +
          '">' +
          self.host().host_name() +
          "</a>"
        );
      } else if (self.creator() != undefined) {
        return self.creator().display_name();
      }
    };

    self.update_event_history = function (e, event_history) {
      self.event_history(
        ko.utils.arrayMap(
          ko.utils.arrayFilter(event_history || [], function (x) {
            if (x.event_action) {
              return x.event_action.event_state != "created";
            } else return x;
          }),
          function (x) {
            x.event_obj = e;
            x.perspective = self.perspective;
            return new SCEventStateMessageMixed(x);
          }
        )
      );
    };

    self.budget_pop_title = ko.pureComputed(function () {
      if (typeof i18nextko != "undefined" && i18nextko.i18n.translator) {
        return i18nextko.i18n.translator.translate("search.budget.help.title");
      }
    });

    self.budget_pop_content = ko.computed(function () {
      if (
        typeof i18nextko != "undefined" &&
        i18nextko.i18n.translator &&
        self.rootvm &&
        self.rootvm.exchange_rates &&
        self.rootvm.exchange_rates() != undefined &&
        self.artist()
      ) {
        if (self.artist().fee_min() <= 0) {
          return i18nextko.i18n.translator.translate("search.budget.request");
        } else {
          if (
            self.current_state() &&
            self.current_state().fee_currency() &&
            self.artist().fee_currency()
          ) {
            var fee_min = self.artist().fee_min();
            var fee_mid = self.artist().fee_mid();
            var fee_max = self.artist().fee_max();
            if (
              self.current_state().fee_currency().iso_currency_code !=
              self.artist().fee_currency().iso_currency_code
            ) {
              fee_min = global_currency_exchange(
                fee_min,
                self.artist().fee_currency().iso_currency_code,
                self.current_state().fee_currency().iso_currency_code,
                self.rootvm.exchange_rates()
              );

              fee_mid = global_currency_exchange(
                fee_mid,
                self.artist().fee_currency().iso_currency_code,
                self.current_state().fee_currency().iso_currency_code,
                self.rootvm.exchange_rates()
              );
              fee_max = global_currency_exchange(
                fee_max,
                self.artist().fee_currency().iso_currency_code,
                self.current_state().fee_currency().iso_currency_code,
                self.rootvm.exchange_rates()
              );
            }
            return i18nextko.i18n.translator.translate(
              "search.budget.help.artist",
              {
                min_fee: fee_min,
                mid_fee: fee_mid,
                max_fee: fee_max,
                currency: self.current_state().fee_currency().symbol,
              }
            );
          }
        }
      }
    });

    self.update_self = function (e, update_artist) {
      //  Latest Message
      //console.log(e.latest_message);
      self.latest_message_actor(e.latest_message_actor);
      self.latest_message_read(e.latest_message_read);
      self.latest_message_inserted(new moment(e.latest_message_inserted));
      //self.latest_message(e.latest_message);
      //
      e.artist.rootvm = self.rootvm;
      e.creator.rootvm = self.rootvm;
      if (e.host) {
        e.host.rootvm = self.rootvm;
        self.host(new Host(e.host));
      }

      if (update_artist !== false) {
        self.artist(new Artist(e.artist));
      }

      self.creator(new Person(e.creator));

      self.update_event_history(e, e.event_history);

      e.current_state.parent_event = e;
      self.current_state(new SCEventState(e.current_state));

      // Set up our event location
      if (e.location) {
        self.event_location(e.location.location_name);
        self.latitude(e.location.latitude);
        self.longitude(e.location.longitude);
      } else if (e.host && e.host.location) {
        self.event_location(e.host.location.location_name);
      }

      self.initiator(e.initiator);
      self.event_type(e.event_type);
      self.event_title(e.event_title);
      self.event_info(e.event_info);

      self.confirmed_event_date(e.confirmed_event_date);
      self._confirmed_event_date_moment(new moment(e.confirmed_event_date));
      self.confirmed_event_time(e.confirmed_event_time);
      self.video_delivered(e.video_delivered);

      self.special_commission_rate(e.special_commission_rate);
      self.special_booking_charge_rate(e.special_booking_charge_rate);

      self.external_email_address(e.external_email_address);
      self.external_contact_name(e.external_contact_name);
      self.billing_email_address(e.billing_email_address);

      self.event_privacy(e.event_privacy);
      self.artist_share_phone(e.artist_share_phone);
      self.host_share_phone(e.host_share_phone);
      self.stored_message(e.stored_message);

      if (e.commission_invoice) {
        e.commission_invoice.rootvm = self.rootvm;
        self.commission_invoice(new Invoice(e.commission_invoice));
      }

      if (e.fee_invoice) {
        e.fee_invoice.rootvm = self.rootvm;
        self.fee_invoice(new Invoice(e.fee_invoice));
      }

      // Reviews
      self.feedback_from_host(new ReviewFeedback(e.feedback_from_host));
      self.feedback_from_artist(new ReviewFeedback(e.feedback_from_artist));

      self.messages(
        ko.utils.arrayMap(e.messages || [], function (x) {
          x.parent_event = self;
          return new Message(x);
        })
      );
    };

    self.lookup_details = function (update_artist) {
      var url = self.rootvm.web_host + "/api/event/details";

      return $.ajax({
        url: url,
        type: "GET",
        data: {
          event_uuid: self.event_uuid(),
        },

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success == true) {
            self.update_self(data.event, update_artist);

            if (self.stored_message()) {
              possible_stored_message_obs(self.stored_message());
            }
          }

          if (data.emails) {
            window.open(data.emails[0], "blank");
            window.open(data.emails[1], "blank");
          }
        },

        error: function (data) {
          console.log(data.responseText);
        },
      });
    };

    self.lookup_filtered_messages = async () => {
      const url = scvm.web_host + "/api/admin/event/filtered-messages";
      const params = new URLSearchParams({
        event_uuid: self.event_uuid(),
      });
      const request = new Request(url + "?" + params.toString(), {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
        }),
      });
      const response = await fetch(request);
      if (response.ok) {
        const data = await response.json();
        console.log(data);
        if (data.success) {
          self.messages(
            ko.utils.arrayMap(data.messages || [], function (x) {
              x.parent_event = self;
              return new Message(x);
            })
          );
        } else {
          throw new Error(data.message);
        }
      } else {
        console.log(response.statusText);
        throw new Error(response.statusText);
      }
    };

    self.lookup_allow_contact = async () => {
      const url = scvm.web_host + "/api/admin/event/allow-contact";
      const params = new URLSearchParams({
        event_uuid: self.event_uuid(),
      });
      const request = new Request(url + "?" + params.toString(), {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
        }),
      });
      const response = await fetch(request);
      if (response.ok) {
        const data = await response.json();
        console.log(data);
        if (data.success) {
          self.messages(
            ko.utils.arrayMap(data.messages || [], function (x) {
              x.parent_event = self;
              return new Message(x);
            })
          );
        } else {
          throw new Error(data.message);
        }
      } else {
        console.log(response.statusText);
        throw new Error(response.statusText);
      }
    };
    self.compare_message = ko.observable();
    self.lookup_filter_popup_shown = async () => {
      self.compare_message(undefined);
      const url = scvm.web_host + "/api/admin/event/filter-popup-shown";
      const params = new URLSearchParams({
        event_uuid: self.event_uuid(),
      });
      const request = new Request(url + "?" + params.toString(), {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
        }),
      });
      const response = await fetch(request);
      if (response.ok) {
        const data = await response.json();
        console.log(data);
        if (data.success) {
          self.messages(
            ko.utils.arrayMap(data.messages || [], function (x) {
              x.parent_event = self;
              return new Message(x);
            })
          );

          if (data.e_message) {
            self.compare_message(new Message(data.e_message));
          }
        } else {
          throw new Error(data.message);
        }
      } else {
        console.log(response.statusText);
        throw new Error(response.statusText);
      }
    };

    self.lookup_messages = function () {
      var url = self.rootvm.web_host + "/api/event/messages";

      return $.ajax({
        url: url,
        type: "GET",
        data: {
          event_uuid: self.event_uuid(),
          sort: "desc",
        },

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success == true) {
            self.messages(
              ko.utils.arrayMap(data.messages || [], function (x) {
                return new Message(x);
              })
            );
          }
        },

        error: function (data) {
          self.error(data.statusText);
        },
      });
    };

    // Event Computables
    // Most recent action in event history
    self.latest_action = ko.computed(function () {
      return self.current_state();
    });

    // Most recent message
    self.latest_message = ko.computed(function () {
      if (self.event_history().length > 0) {
        return self.event_history()[0].message;
      }
    });

    // We've got some fun stuff here to deal with translation strings
    // for request row
    //
    // At some point it'd be good to rework this, but for now bear with me ;)
    self.latest_action_actor = ko.computed(function () {
      if (self.latest_action()) {
        if (self.latest_action().event_action()) {
          return self.latest_action().actor();
        } else if (self.latest_action().message()) {
          return self.latest_action().message().actor();
        }
      }
    });

    self.i18nActionSelfOrOther = function (actionActor) {
      // if I am the actor of the latest action, then it's me.
      // otherwise it's other
      if (self.perspective != undefined && actionActor != undefined) {
        return self.perspective === actionActor ? "self" : "other";
      } else {
        return "";
      }
    };

    self.i18nEventAction = ko.computed(function () {
      if (self.latest_action() && self.latest_action().event_action()) {
        var event_action = self.latest_action().event_action();
        var event_state = self.latest_action().event_state();

        if (event_action == "invite") {
          return event_state + "_invitation_byhost";
        } else if (event_action == "request") {
          return event_state + "_request_byartist";
        } else if (event_action == "artist_changes_offer") {
          return event_state + "_alternative_byartist";
        } else if (event_action == "host_changes_offer") {
          return event_state + "_alternative_byhost";
        } else if (event_action == "approve") {
          return event_state + "_approval_byartist";
        } else if (event_action == "confirm") {
          return "confirmed_byhost";
        } else if (event_action == "no") {
          return event_state + "_by" + self.latest_action_actor();
        } else if (event_action == "cancel") {
          return event_state + "_by" + self.latest_action_actor();
        }
      }

      // otherwise we have a message
      else if (self.latest_action() && self.latest_action().message()) {
        if (self.latest_action().message().actor() == "host") {
          return "question_" + "byhost";
        } else if (self.latest_action().message().actor() == "artist") {
          return "question_" + "byartist";
        }
      }
    });

    self.action = ko.pureComputed(function () {
      let actionString;

      if (!self.current_state()) {
        return;
      }

      if (self.current_state().event_state() == "expired") {
        actionString = "manage_concerts.negotiation." + self.latest_action();
      } else {
        actionString =
          "manage_concerts.negotiation." +
          self.i18nActionSelfOrOther(self.latest_action_actor()) +
          "." +
          self.i18nEventAction();
      }
      return actionString + "._";
    });

    self.i18nParams = ko.computed(function () {
      if (self.latest_action()) {
        var sender, receiver;
        if (self.latest_action_actor() === "artist") {
          sender = self.artist().artist_name();
          receiver = self.host_salutation();
        } else {
          sender = self.host_salutation();
          receiver = self.artist().artist_name();
        }
        // i18next is removed
        //var event_type_trans = i18nextko.i18n.translator.translate ('general.category.' + self.event_type() + '._' );
        var event_type_trans = self.event_type();

        return {
          host: self.host_salutation(),
          artist: self.artist().artist_name(),
          sender: sender,
          receiver: receiver,
          type: event_type_trans,
        };
      } else {
        return {};
      }
    });

    // fee stuff
    self.fee_mode = ko.computed(function () {
      if (self.current_state() && self.current_state().fee_mode()) {
        return self.current_state().fee_mode();
      } else {
        // Default if it's not set
        return "playingforhat";
      }
    });

    self.sum = ko.computed(function () {
      if (
        self.current_state() &&
        self.current_state().calculated_event_fees()
      ) {
        return self.current_state().calculated_event_fees().brutto;
      }
    });

    self.earnings = ko.computed(function () {
      if (
        self.current_state() &&
        self.current_state().calculated_event_fees()
      ) {
        return self.current_state().calculated_event_fees.artist_payment;
      }
    });

    // Admin Page Stuff
    self.payin_date = ko.computed(function () {
      if (self.fee_invoice() != undefined) {
        return self.fee_invoice().paid_date();
      } else if (self.commission_invoice() != undefined) {
        return self.commission_invoice().paid_date();
      }
    });

    self.invoice_date = ko.computed(function () {
      if (self.fee_invoice() != undefined) {
        return self.fee_invoice().invoice_date();
      }
    });

    self.payout_date = ko.computed(function () {
      if (self.commission_invoice() != undefined) {
        return self.commission_invoice().paid_date();
      }
    });

    self.cancelled_date = ko.computed(function () {
      if (
        self.current_state() &&
        self.current_state().event_state() == "cancelled"
      ) {
        return new moment(self.current_state().inserted()).format("DD.MM.YYYY");
      }
    });

    self.planned_payout_date = ko.computed(function () {
      if (self.payout_date()) {
        return self.payout_date();
      }
      if (self.commission_invoice() && self._confirmed_event_date_moment()) {
        return self
          ._confirmed_event_date_moment()
          .add(7, "days")
          .format("DD.MM.YYYY");
      }
    });

    self.send_kyc_email = function () {
      const invoice_number = self.fee_invoice()
        ? self.fee_invoice().invoice_number()
        : null;

      return $.ajax({
        url: "/api/artist/kyc-reminder-email",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          artist_uuid: self.artist_uuid(),
          invoice_number: invoice_number,
        }),

        complete: function (data) {},

        success: function (data) {
          if (data.success) {
            notyf.success("Email sent");
            console.log(data.email);
            self.artist().last_kyc_reminder_email_sent(data.last_sent);
          } else {
            console.log(data.message);
          }
        },
        error: function (data) {},
      });
    };

    function ArtistBankDetails(data = {}) {
      var self = this;
      self.type = "ArtistBankDetails";

      self.bank_account_uuid = ko.observable(data.bank_account_uuid);
      self.iban = ko.observable(data.bank_account?.iban);
      self.bic = ko.observable(data.bank_account?.bic);
      self.owner_name = ko.observable(data.bank_account?.owner_name);
    }
    self.selected_artist_bank_details = ko.observable(new ArtistBankDetails());
    self.get_artist_bank_details = function () {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/bank-details",
        type: "GET",
        data: {
          artist_uuid: self.artist().artist_uuid(),
        },

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          var bank_details = "BANK ACCOUNT";
          if (data.billing_details.bank_account_uuid) {
            self.selected_artist_bank_details(
              new ArtistBankDetails(data.billing_details)
            );
          } else {
            bank_details = "No Bank Details for Artist";
            alert(bank_details);
          }
        },
        error: function (data) {
          notyf.error(data.message);
        },
        complete: function () {
          //self.rootvm.is_busy(false);
        },
      });
    };

    self.mango_payout = function () {
      var answer = confirm("You are creating a MANGO PAYOUT. Are you sure?");

      if (answer) {
        self.mango_payout_request(false);
      }
    };

    self.mango_payout_request = function (force) {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/pay-out",
        type: "POST",
        data: ko.toJSON({
          invoice_uuid: self.commission_invoice().invoice_uuid(),
          force: force,
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            data.payout.rootvm = self.rootvm;
            self.commission_invoice().payout(new Payout(data.payout));
            notyf.success("Pay out created!");
          } else if (data.force_required) {
            if (confirm(data.message + "\n\nForce the payout anyway?")) {
              self.mango_payout_request(true);
            }
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {
          //self.rootvm.is_busy(false);
        },
      });
    };

    self.mango_payout_over_master = function () {
      var answer = confirm(
        "You are creating a MANGO PAYOUT over our master wallet. Please doublecheck that the banke details are correct before confirming. Please note that the money should be on the artist wallet alreayd. This will not do an automatic transfer. Confirm?"
      );

      if (answer) {
        //self.rootvm.is_busy(true);
        return $.ajax({
          url: self.rootvm.web_host + "/api/admin/pay-out-master",
          type: "POST",
          data: ko.toJSON({
            invoice_uuid: self.commission_invoice().invoice_uuid(),
          }),
          processData: false,

          contentType: "application/json; charset=utf-8",

          success: function (data) {
            if (data.success) {
              data.payout.rootvm = self.rootvm;
              self.commission_invoice().payout(new Payout(data.payout));
              notyf.success("Pay out created!");
            } else {
              notyf.error(data.message);
            }
          },
          error: function (jqXHR, errorStatus, thrownError) {
            var response = jQuery.parseJSON(jqXHR.responseText);
            notyf.error(response.message);
          },
          complete: function () {
            //self.rootvm.is_busy(false);
          },
        });
      }
    };

    self.mark_as_paid_out = function () {
      var answer = confirm("You are marking an invoice as paid. Are you sure?");
      if (answer) {
        return $.ajax({
          url: self.rootvm.web_host + "/api/admin/pay-in",
          type: "POST",
          data: ko.toJSON({
            invoice_uuid: self.commission_invoice().invoice_uuid(),
          }),
          processData: false,

          contentType: "application/json; charset=utf-8",

          success: function (data) {
            if (data.success) {
              self
                .commission_invoice()
                .paid_date(new moment(data.paid_date).format("DD.MM.YY"));
              notyf.success("Paid!");
            } else {
              notyf.error(data.message);
            }
          },
          error: function (jqXHR, errorStatus, thrownError) {
            var response = jQuery.parseJSON(jqXHR.responseText);
            notyf.error(response.message);
          },
          complete: function () {},
        });
      }
    };

    self.mark_as_paid_in = function () {
      return self.fee_invoice().mark_as_paid_in();
    };

    self.request_feedback_artist = function () {
      var answer = confirm("send an email to the artist?");

      if (answer) {
        //self.rootvm.is_busy(true);
        return $.ajax({
          url:
            self.rootvm.web_host + "/api/admin/event/request-feedback-artist",
          type: "POST",
          data: ko.toJSON({
            event_uuid: self.event_uuid(),
          }),
          processData: false,
          contentType: "application/json; charset=utf-8",

          success: function (data) {
            if (data.success) {
              notyf.success("Sent email!");
            } else {
              notyf.error(data.message);
            }
          },
          error: function (data) {
            notyf.error(data);
          },
          complete: function () {
            //self.rootvm.is_busy(false);
          },
        });
      }
    };

    self.request_feedback_host = function () {
      var answer = confirm("send an email to the host?");

      if (answer) {
        //self.rootvm.is_busy(true);
        return $.ajax({
          url: self.rootvm.web_host + "/api/admin/event/request-feedback-host",
          type: "POST",
          data: ko.toJSON({
            event_uuid: self.event_uuid(),
          }),
          processData: false,
          contentType: "application/json; charset=utf-8",

          success: function (data) {
            if (data.success) {
              notyf.success("Sent email!");
            } else {
              notyf.error(data.message);
            }
          },
          error: function (data) {
            notyf.error(data);
          },
          complete: function () {
            //self.rootvm.is_busy(false);
          },
        });
      }
    };

    self.get_login_link = function (perspective) {
      if (perspective == "host") {
        self.host_login_link(undefined);
      } else {
        self.artist_login_link(undefined);
      }
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/get-login-event-link",
        type: "GET",
        data: {
          event_uuid: self.event_uuid(),
          perspective: perspective,
        },
        contentType: "application/json; charset=utf-8",

        success: function (result) {
          var login_link;
          login_link = result.login_link;
          if (perspective == "host") {
            self.host_login_link(login_link);
          } else {
            self.artist_login_link(login_link);
          }
        },

        error: function (data) {
          console.log(data.message);
        },
      });
    };

    self.cancel_extra_notes = function () {
      self.new_extra_notes(self.extra_notes());
      self.editing_extra_notes(false);
    };

    self.event_privacy.subscribeChanged(function (newValue, oldValue) {
      if (oldValue != undefined) {
        self.save_event_privacy();
      }
    });

    self.save_event_privacy = function () {
      var concert_data = {
        event_privacy: self.event_privacy(),
        concert_uuid: self.event_uuid(),
      };
      var url = "/api/concert/update";
      return $.ajax({
        url: url,
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON(concert_data),

        complete: function (data) {},

        success: function (data) {
          if (data.success) {
          } else {
            console.log(data.message);
          }
        },
        error: function (data) {},
      });
    };

    self.save_extra_notes = function () {
      self.editing_extra_notes(false);

      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/event/extra-notes",
        type: "POST",
        data: ko.toJSON({
          event_uuid: self.event_uuid(),
          extra_notes: self.new_extra_notes(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.extra_notes(data.extra_notes);
            self.new_extra_notes(data.extra_notes);
            self.editing_extra_notes(false);
            notyf.success("Saved!");
          } else {
            notyf.error(data.message);
            self.editing_extra_notes(true);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.admin_close = function () {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/event/close",
        type: "POST",
        data: ko.toJSON({
          event_uuid: self.event_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.admin_closed(data.admin_closed);
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {
          //self.rootvm.is_busy(false);
        },
      });
    };

    self.admin_un_close = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/event/un-close",
        type: "POST",
        data: ko.toJSON({
          event_uuid: self.event_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.admin_closed(data.admin_closed);
            notyf.success("un cancelled");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.admin_mark = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/event/mark",
        type: "POST",
        data: ko.toJSON({
          event_uuid: self.event_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.admin_marked(data.admin_marked);
            notyf.success("Marked!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
      });
    };

    self.admin_un_mark = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/event/un-mark",
        type: "POST",
        data: ko.toJSON({
          event_uuid: self.event_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.admin_marked(data.admin_marked);
            notyf.success("un marked");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
      });
    };

    self.mark_paket_sent = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/event/paket-sent",
        type: "POST",
        data: ko.toJSON({
          event_uuid: self.event_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.paket_sent(data.sent);
            notyf.success("Marked as sent!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
      });
    };
  }
}
export class SCEventStateMessageMixed {
  constructor(data) {
    var self = this;
    self.type = "EventStateMessageMixed";

    self.message = ko.observable();

    self.event_obj = ko.observable();

    if (typeof data.event_obj == "object" && data.event_obj.type == "SCEvent") {
      self.event_obj(data.event_obj);
    } else {
      self.event_obj(new SCEvent(data.event_obj));
    }

    self.perspective = data.perspective;

    self.event_state = ko.observable();
	self.event_call = ko.observable();
    if (data.message) {
      self.message(new Message(data.message));
    }
    if (data.event_action) {
      self.event_state(new SCEventState(data.event_action));
      self.event_state().message(self.message());
    }

    if(data.event_call){
      self.event_call(new SCEventCallState(data.event_call));
    }

  }
}
export class CalculatedEventFees {
  constructor(data) {
    var self = this;

    self.type = "CalculatedEventFees";

    //console.log(data);
    self.artist_payment = ko.observable(data.artist_payment);
    self.fee_vat = ko.observable(data.fee_vat);
    self.host_fee = ko.observable(data.host_fee);
    self.sofaconcerts_fee = ko.observable(data.sofaconcerts_fee);
    self.booking_charge = ko.observable(data.booking_charge);
    self.commission = ko.observable(data.commission);

    self.charge_rate = ko.observable(data.charge_rate);
    self.commission_percent = ko.observable(20);
    if (data.commission_dict) {
      self.commission_percent(data.commission_dict.commission_percentage);
    }

    self.brutto = ko.observable(data.brutto);
    self.host_fee = ko.observable(data.host_fee);

    self.gift_amount_remaining = ko.observable(data.gift_amount_remaining);
    self.gift_amount_used = ko.observable(data.gift_amount_used);
  }
}

export class SCEventState {
  constructor(data) {
    var self = this;
    self.type = "EventState";

    self.rootvm = data.rootvm;

    self.parent_event = ko.observable(data.parent_event);
    self.event_state = ko.observable(data.event_state);
    self.event_action = ko.observable(data.event_action);
    self.decline_reasons = ko.observableArray(data.decline_reasons);
    // Artists the declining artist suggested (name + picture + uuid).
    self.recommendations_by_artist_details = ko.observableArray(
      data.recommendations_by_artist_details || []
    );
    self.inserted = ko.observable(data.inserted);
    self.inserted_mom = ko.observable(new moment(data.inserted));
    self.inserted_by = ko.observable(data.inserted_by);
    self.fee_mode = ko.observable(data.fee_mode);
    self.fee = ko.observable(data.fee);

    self.fee_currency = ko.observable(
      ko.utils.arrayFirst(GLOBAL_CURRENCIES, function (item) {
        if (item.iso_currency_code == data.fee_currency) {
          return item;
        }
      })
    );
    self.artist_payment = ko.observable();
    self.fee_vat = ko.observable();
    self.host_fee = ko.observable();
    self.sofaconcerts_fee = ko.observable();

    self.actor = ko.observable(data.actor);

    self.calculated_event_fees = ko.observable();

    self.set_calculated_event_fees = function (calculated_event_fees) {
      self.artist_payment(calculated_event_fees.artist_payment);
      self.fee_vat(calculated_event_fees.fee_vat);
      self.host_fee(calculated_event_fees.brutto_host_fee);
      self.sofaconcerts_fee(calculated_event_fees.sofaconcerts_fee);
      self.calculated_event_fees(
        new CalculatedEventFees(calculated_event_fees)
      );
    };

    if (data.calculated_event_fees) {
      self.set_calculated_event_fees(data.calculated_event_fees);
    }

    self.booking_charge = ko.computed(function () {
      if (
        self.calculated_event_fees() &&
        typeof self.calculated_event_fees().booking_charge != "undefined"
      ) {
        return self.calculated_event_fees().booking_charge();
      }
    });

    self.commission = ko.computed(function () {
      if (
        self.calculated_event_fees() &&
        typeof self.calculated_event_fees().commission != "undefined"
      ) {
        return self.calculated_event_fees().commission();
      }
    });

    self.possible_dates = ko.observableArray([]);

    self.possible_dates(
      ko.utils.arrayMap(data.possible_dates || [], function (x) {
        return new moment(x);
      })
    );

    self.days_before_possible_date = ko.pureComputed(function () {
      if (self.possible_dates().length > 0) {
        return self
          .possible_dates()[0]
          .diff(self.parent_event().inserted(), "days");
      } else {
        return "";
      }
    });

    self.current_days_before_possible_date = ko.pureComputed(function () {
      if (self.possible_dates().length > 0) {
        return self.possible_dates()[0].diff(new moment(), "days");
      } else {
        return "";
      }
    });

    self.effective_start = ko.observable();
    self.effective_end = ko.observable();
    if (data.effective) {
      self.effective_end(data.effective.lower);

      if (data.effective.upper.indexOf("9999") != 0) {
        self.effective_end(data.effective.upper);
      }
    }

    self.message = ko.observable();

    /*
        We don't use i18n in admin
        self.i18n_state = ko.computed(function(){
            switch ( self.event_state() ) {
                case 'created':
                case 'waiting_for_approval':
                case 'waiting_for_confirmation':
                    return 'manage_concerts.infobox.state.open' ;
                case 'cancelled':
                    return 'manage_concerts.infobox.state.cancelled' ;
                case 'no':
                    return 'manage_concerts.infobox.state.cancelled' ;
                case 'expired':
                    return 'manage_concerts.infobox.state.cancelled' ;
                case 'confirmed':
                    if ( self.parent_event() && self.parent_event().confirmed_event_date ) {

                        d = new moment(self.parent_event().confirmed_event_date);
                        if (d.isAfter(moment())) {
                            return 'manage_concerts.infobox.state.confirmed' ;
                        }
                        else {
                            return 'manage_concerts.infobox.state.past' ;
                        }
                    }
                default:
                    return self.event_state() ;
            }

        });
        */
  }
}
export class SCEventCallState {
  constructor(data) {
      var self = this;
      self.type = "SCEventCallstate";

      self.rootvm = data.rootvm;

      self.call_uuid = data.call_uuid;

      self.inserted = new moment(data.inserted);

      self.call_state = data.call_state;
      self.inserted_by = data.inserted_by;
      self.actor = data.actor;
      self.message = data.message;
      self.seen_by_user = data.seen_by_user;
  }
}

export class ReviewFeedback {
  constructor(data) {
    var self = this;
    self.type = "ReviewFeedback";

    if (!data) {
      data = {};
    }
    self.feedback = ko.observable(data.feedback);

    self.sofaconcerts_feedback = ko.observable(data.sofaconcerts_feedback);
    self.instagram_image_path_de = ko.observable(data.instagram_image_path_de);
    self.instagram_image_path_en = ko.observable(data.instagram_image_path_en);
    self.inserted = ko.observable(data.inserted);
    self.rating = ko.observable(data.rating);
    // This might be here if we've done a full text search
    self.highlight = ko.observable(data.highlight);
  }
}
//Sometimes we want to display upcoming and past events
//-- we don't need full data for artist/ host/ event
//   so we use this combo class to put it together and display it

export class RequestListEvent {
  constructor(data) {
    var self = this;
    self.type = "RequestListEvent";

    self.rootvm = data.rootvm;
    self.perspective = data.perspective;
    self.ev_status = data.ev_status;

    self.artist_uuid = ko.observable(data.artist_uuid);
    self.artist_name = ko.observable(data.artist_name);
    self.artist_username = ko.observable(data.artist_username);
    self.artist_pro = ko.observable(data.artist_pro);
    self.artist_profile_photo = ko.observable(data.artist_profile_photo);
    self.artist_deleted = ko.observable(data.artist_deleted);

    // the event stuff
    self.event_date = ko.observable(new moment(data.event_date));
    self._event_date = ko.observable(data.event_date);
    self.event_inserted = ko.observable(data.event_inserted);
    self.event_location = ko.observable(data.event_location);
    self.event_title = ko.observable(data.event_title);
    self.event_type = ko.observable(data.event_type);
    self.event_uuid = ko.observable(data.event_uuid);
    self.external_web_link = ko.observable(data.external_web_link);
    self.genres = ko.observableArray(data.genres || []);
    self.host_name = ko.observable(data.host_name);
    self.host_username = ko.observable(data.host_username);
    self.host_person_display_name = ko.observable(
      data.host_person_display_name
    );
    self.host_profile_photo = ko.observable(data.host_profile_photo);
    self.host_uuid = ko.observable(data.host_uuid);
    self.host_deleted = ko.observable(data.host_deleted);
    self.host_person_deleted = ko.observable(data.host_person_deleted);
    self.current_state = ko.observable(data.current_state);

    self.latest_action = ko.observable(data.latest_action);
    self.latest_action_actor = ko.observable(data.latest_action_actor);
    self.latest_action_inserted = ko.observable(
      new moment(data.latest_action_inserted)
    );
    self.latest_message = ko.observable(data.latest_message);
    self.latest_message_inserted = ko.observable(
      new moment(data.latest_message_inserted)
    );
    self.latest_message_read = ko.observable(data.latest_message_read);
    self.latest_message_actor = ko.observable(data.latest_message_actor);

    self.is_external = ko.computed(function () {
      return self.event_type() == "external";
    });

    self.event_href = ko.computed(function () {
      if (self.is_external()) {
        return "../add-external?event_uuid=" + self.event_uuid();
      }
      return "../" + self.event_uuid();
    });

    self.formatted_event_date = function (format) {
      if (self.event_date() && self._event_date()) {
        return self.event_date().format(format);
      } else if (format == "DD") {
        return "?";
      } else {
        return "tbd";
      }
    };

    self.host_pic = ko.computed(function () {
      if (self.host_deleted() || self.host_person_deleted()) {
        return "/images/icon/category-sofaconcert.png";
      } else if (
        self.host_uuid() &&
        (self.event_type() == "sofaconcert" || self.event_type() == "contest")
      ) {
        return self.host_profile_photo();
      } else if (self.event_type() != undefined) {
        return "/images/icon/category-" + self.event_type() + ".png";
      } else {
        return "/images/icon/category-sofaconcert.png";
      }
    });

    self.pretty_host_name = ko.computed(function () {
      if (self.host_deleted() || self.host_person_deleted()) {
        return i18nextko.i18n.translator.translate(
          "modal.error.host_not_found.name"
        );
      } else if (self.host_uuid()) {
        return self.host_name();
      } else if (self.event_title()) {
        return self.event_title();
      } else {
        var category_trans = i18nextko.i18n.translator.translate(
          "general.category." + self.event_type() + "._"
        );

        return category_trans;
      }
    });

    self.pretty_genres = ko.computed(function () {
      return self.genres().join(", ");
    });

    // If host or artist deleted, show location as blank
    //
    if (
      self.artist_deleted() ||
      self.host_deleted() ||
      self.host_person_deleted()
    ) {
      self.event_location("");
    }

    if (self.artist_deleted()) {
      self.artist_name(
        i18nextko.i18n.translator.translate("modal.error.artist_not_found.name")
      );
    }

    if (self.host_person_deleted() || self.host_deleted()) {
      self.host_person_display_name(
        i18nextko.i18n.translator.translate("modal.error.host_not_found.name")
      );
    }

    // These also appear in Event -- need to unify...
    self.i18nActionSelfOrOther = function (actionActor) {
      // if I am the actor of the latest action, then it's me.
      // otherwise it's other
      if (self.perspective != undefined && actionActor != undefined) {
        return self.perspective === actionActor ? "self" : "other";
      } else {
        return "";
      }
    };

    self.i18nEventAction = function (action, current_state, actor) {
      if (action == "invite") {
        return current_state + "_invitation_byhost";
      } else if (action == "request") {
        return current_state + "_request_byartist";
      } else if (action == "artist_changes_offer") {
        return current_state + "_alternative_byartist";
      } else if (action == "host_changes_offer") {
        return current_state + "_alternative_byhost";
      } else if (action == "approve") {
        return current_state + "_approval_byartist";
      } else if (action == "confirm") {
        return current_state + "_byhost";
      } else if (action == "no") {
        return current_state + "_by" + actor;
      } else if (action == "cancel") {
        return current_state + "_by" + actor;
      }
    };

    // We've got some fun stuff here to deal with translation strings
    // for request row
    //
    // At some point it'd be good to rework this, but for now bear with me ;)
    self.action = ko.computed(function () {
      var action_string;

      if (self.current_state() == "expired") {
        actionString = "manage_concerts.negotiation." + self.latest_action();
      } else {
        actionString =
          "manage_concerts.negotiation." +
          self.i18nActionSelfOrOther(self.latest_action_actor()) +
          "." +
          self.i18nEventAction(
            self.latest_action(),
            self.current_state(),
            self.latest_action_actor()
          );
      }
      return actionString + "._";
    });

    self.i18nParams = ko.computed(function () {
      if (self.latest_action()) {
        var sender, receiver;
        if (self.latest_action_actor() === "artist") {
          sender = self.artist_name();
          receiver = self.host_person_display_name();
        } else {
          sender = self.host_person_display_name();
          receiver = self.artist_name();
        }

        // i18next is removed
        //var category_trans = i18nextko.i18n.translator.translate('general.category.' + self.event_type() + '._' );
        var category_trans = self.event_type();

        if (self.event_title()) {
          category_trans = self.event_title();
        }

        return {
          host: self.host_person_display_name(),
          artist: self.artist_name(),
          sender: sender,
          receiver: receiver,
          type: category_trans,
        };
      } else {
        return {};
      }
    });
    /*
        self.mark_read = function() {
            if (self.latest_message_read() == null && self.latest_message_actor() != self.perspective) {
                return $.ajax({
                    url: "/api/user/event/mark-read",
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    processData: false,

                    data: ko.toJSON({
                        event_uuid: self.event_uuid(),
                    }),

                    success: function (data) {
                        if (data.success) {
                            switch (self.ev_status) {
                                case 'open':
                                    if (self.perspective === 'artist') {
                                        self.rootvm.unread_msgs_artist().open.decrement(data.marked_rows)
                                    } else {
                                        self.rootvm.unread_msgs_host().open.decrement(data.marked_rows)
                                    }
                                    break;
                                case 'cancelled':
                                    if (self.perspective === 'artist') {
                                        self.rootvm.unread_msgs_artist().cancelled.decrement(data.marked_rows)
                                    } else {
                                        self.rootvm.unread_msgs_host().cancelled.decrement(data.marked_rows)
                                    }
                                    break;
                                case 'upcoming':
                                    if (self.perspective === 'artist') {
                                        self.rootvm.unread_msgs_artist().upcoming.decrement(data.marked_rows)
                                    } else {
                                        self.rootvm.unread_msgs_host().upcoming.decrement(data.marked_rows)
                                    }
                                    break;
                                case 'passed':
                                    if (self.perspective === 'artist') {
                                        self.rootvm.unread_msgs_artist().passed.decrement(data.marked_rows)
                                    } else {
                                        self.rootvm.unread_msgs_host().passed.decrement(data.marked_rows)
                                    }
                                    break;
                                default:
                                    break;
                            }
                        } else {
                            console.log(data.error);
                            console.log('error marking read');
                        }
                    }
                });
            }
        }
        */
    self.mark_row = ko.computed(function () {
      if (
        !self.is_external() &&
        self.latest_message_read() == null &&
        self.latest_message_actor() != self.perspective
      ) {
        return "#D4EDEE";
      } else {
        return;
      }
    });
  }
}
export class FrontendEvent {
  constructor(data) {
    var self = this;
    self.type = "FrontendEvent";

    self.artist_uuid = ko.observable(data.artist_uuid);
    self.artist_name = ko.observable(data.artist_name);
    self.artist_username = ko.observable(data.artist_username);
    self.artist_pro = ko.observable(data.artist_pro);
    self.artist_profile_photo = ko.observable(data.artist_profile_photo);

    // the event stuff
    self.confirmed_event_date = ko.observable(
      new moment(data.confirmed_event_date)
    );
    self._confirmed_event_date = ko.observable(data.confirmed_event_date);
    self.event_uuid = ko.observable(data.event_uuid);
    self.event_inserted = ko.observable(data.event_inserted);
    self.event_location = ko.observable(data.event_location);

    self.event_title = ko.observable(data.event_title);
    self.event_type = ko.observable(data.event_type);
    self.event_uuid = ko.observable(data.event_uuid);
    self.external_web_link = ko.observable(data.external_web_link);
    self.genres = ko.observableArray(data.genres || []);
    self.host_name = ko.observable(data.host_name);
    self.host_username = ko.observable(data.host_username);
    self.host_profile_photo = ko.observable(data.host_profile_photo);
    self.host_uuid = ko.observable(data.host_uuid);

    self.formatted_event_date = function (format) {
      if (self._confirmed_event_date()) {
        return self.confirmed_event_date().format(format);
      } else {
        return "?";
      }
    };

    self.host_pic = ko.computed(function () {
      if (self.host_uuid()) {
        return self.host_profile_photo();
      } else if (self.event_type() != undefined) {
        return "/images/icon/category-" + self.event_type() + ".png";
      } else {
        return "/images/icon/category-sofaconcert.png";
      }
    });

    self.pretty_genres = ko.computed(function () {
      return self.genres().join(", ");
    });

    self.host_link = ko.computed(function () {
      if (self.host_uuid()) {
        return "/hosts/" + self.host_username();
      } else {
        switch (self.event_type()) {
          case "external":
            return self.external_web_link();
          case "wedding":
            return "/de/hochzeit";
          case "special_occasion":
            return "/de/band-buchen-wohnzimmerkonzert-geburtstagsgeschenk";
          case "birthday":
            return "/de/geburtstagsfeier";
          case "corporate_event":
            return "/de/firmenfeier";
          default:
            return "/de/band-buchen-wohnzimmerkonzert-geburtstagsgeschenk";
        }
      }
    });
  }
}
